import { createRoot } from 'react-dom/client';
import * as serviceWorker from './serviceWorker';
import { loadScripts } from './utils/resourceLoader';

import App from './containers/app';

//import '@progress/kendo-theme-default/dist/all.css';
//import '@progress/kendo-theme-bootstrap/dist/all.css';
import '@progress/kendo-theme-material/dist/all.css';
import './index.scss';
import './fonts/fonts.css';

if (!String.prototype.replaceAll) {
	String.prototype.replaceAll = function(str, newStr){
		if (Object.prototype.toString.call(str).toLowerCase() === '[object regexp]') {
			return this.replace(str, newStr);
		}
		return this.replace(new RegExp(str, 'g'), newStr);
	};
}

['dragenter', 'dragover', 'dragleave', 'drop'].forEach(eventName => {
  document.addEventListener(eventName, (e) => {
    e.preventDefault();
    e.stopPropagation();
  }, false);
});

(async function () {
  await loadScripts();
  const container = document.getElementById('root');
  const root = createRoot(container);
  root.render(<App />);
})();

serviceWorker.unregister();
